var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",class:'form-control datepicker '+ (_vm.sm ? 'form-control-sm' : ''),style:('width:'+_vm.width+'px; height:'+_vm.height+'px;'),attrs:{"present":_vm.present},domProps:{"value":_vm.value},on:{"change":_vm.updateDatePicker}})
}
var staticRenderFns = []

export { render, staticRenderFns }